import styles from '../styles/ImageStack.module.css';

export default function ImageStack({ images, size = 150 }: {
  images: {
    isVideo: boolean;
    src: string;
  }[],
  size?: number;
}) {
  
  return <div style={{ height: `${size + 50}px`, paddingTop: "8px", display: 'flex', justifyContent: 'center' }}>
    <div style={{ width: `${size}px` }}>
      {images!.map((preview, i) => {
        if (preview.isVideo) {
          return <video
            className={styles.imageStack}
            key={i}
            style={{
              transform: `rotate(${(i - 1) * 6}deg)`,
              opacity: 1 / (i + 1),
              zIndex: -i,
              backgroundColor: "#212328",
              width: `${size}px`,
              height: `${size}px`
            }}
            src={preview.src}
          />;
        } else {
          return <img
            className={styles.imageStack}
            key={i}
            style={{
              transform: `rotate(${(i - 1) * 6}deg)`,
              opacity: 1 / (i + 1),
              zIndex: -i,
              width: `${size}px`,
              height: `${size}px`
            }}
            src={preview.src}
            alt={"image-" + i}
          />
        }
      })}
    </div>
  </div>
}